import { render, staticRenderFns } from "./gaugeCanvas.vue?vue&type=template&id=61394441&scoped=true"
import script from "./gaugeCanvas.vue?vue&type=script&lang=js"
export * from "./gaugeCanvas.vue?vue&type=script&lang=js"
import style0 from "./gaugeCanvas.vue?vue&type=style&index=0&id=61394441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61394441",
  null
  
)

export default component.exports